module.exports = __webpack_public_path__ + "img/notification.8baaa4f8.svg";